import 'firebase/messaging'
import firebase from 'firebase/app'
 let messaging = null
/* eslint-disable no-unused-vars */
if (firebase.messaging.isSupported()) {
  messaging = firebase.messaging()
}
export default messaging
